<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'MitMenuUser',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
    return {
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
